import { avatarAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(avatarAnatomy.keys)

const sizes = {
  '2xs': definePartsStyle({
    container: {
      border: '2px solid',
      borderColor: 'whiteAlpha.500',
    },
  }),
  xs: definePartsStyle({
    container: {
      border: '2px solid',
      borderColor: 'whiteAlpha.500',
    },
  }),
  sm: definePartsStyle({
    container: {
      border: '2px solid',
      borderColor: 'whiteAlpha.500',
    },
  }),
  md: definePartsStyle({
    container: {
      border: '2px solid',
      borderColor: 'whiteAlpha.500',
    },
  }),
  lg: definePartsStyle({
    container: {
      border: '2px solid',
      borderColor: 'whiteAlpha.500',
    },
  }),
  xl: definePartsStyle({
    container: {
      border: '4px solid',
      borderColor: 'whiteAlpha.500',
    },
  }),
  '2xl': definePartsStyle({
    container: {
      border: '4px solid',
      borderColor: 'whiteAlpha.500',
    },
  }),
}

const noBorder = definePartsStyle({
  container: {
    border: 'none',
  },
})

export const Avatar = defineMultiStyleConfig({
  sizes,
  variants: { noBorder },
})
